export const isCardMatch = (maskedCard?: string, fullCard?: string) => {
  if (!fullCard || !maskedCard) {
    return false
  }

  const cleanMask = maskedCard?.replace(/[\s-]/g, '')
  const cleanFull = fullCard?.replace(/[\s-]/g, '')

  if (cleanMask.length !== cleanFull.length || !/^\d+$/.test(cleanFull)) {
    return false
  }

  for (let i = 0; i < cleanMask.length; i++) {
    if (cleanMask[i] !== '*' && cleanMask[i] !== cleanFull[i]) {
      return false
    }
  }

  return true
}
